<template>
  <div class="classic-website">
    <!-- 第一区域：顶部公司信息 -->
    <atop ref="atop"></atop>

    <!-- 第二区域：全站搜索区 -->
    <atopsearch ref="atopsearch"></atopsearch>

    <!-- 新增区域1：书籍基本信息区域 -->
    <section class="book-info-section">
      <div class="container">
        <div class="book-info-container classic-border classic-bg">
          <div class="book-info-header">
            <h1 class="book-title">{{theBookDetail.seriesname}}</h1>
            <el-button 
              class="back-button"
              @click="goBackToPreviousPage"
              size="medium"
            >
              <span class="back-icon">&lt;&nbsp;&nbsp;返回上页</span>
              <!-- <span class="back-text">返回上页</span> -->
            </el-button>
            <el-button v-if="!isWillPublish && !isMobile"
              class="back-button"
              @click="goReadPage"
              size="medium"
            >
              <span class="back-icon">⊙&nbsp;&nbsp;书籍阅读</span>
            </el-button>
          </div>
          
          <div class="book-info-content">
            <!-- 书籍封面 -->
            <div class="book-cover" @click="showImageDialog(`${theBookCover}`, '书籍封面')">
              <img 
                :src="theBookCover"
                alt="书籍封面"
                @error="handleImageError"
              >

              <!-- <div class="cover-hover"> 20260211,手机上不要出现书籍封面点击放大的效果-->
              <div class="cover-hover" v-if="!isMobile">
                <i class="fas fa-search-plus"></i>
                <span>点击放大</span>
              </div>
            </div>
            
            <!-- 书籍信息 -->
            <div class="book-details">
              <!-- 书籍基本信息 -->
              <div class="book-basic-info">
                <div class="info-grid">
                  <div class="info-item">
                    <span class="info-label">I S B N：</span>
                    <span class="info-value">{{theBookDetail.isbn}}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">编 著：</span>
                    <span class="info-value">{{theBookDetail.author}}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">出版社：</span>
                    <span class="info-value">{{theBookDetail.publisher}}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">装帧开本：</span>
                    <span class="info-value">{{theBookDetail.formatsize}}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">出版日期：</span>
                    <span class="info-value">{{theBookDetail.publishdate.substring(0,4)}}年{{theBookDetail.publishdate.substring(5,7)}}月</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">定 价：</span>
                    <!-- <span class="info-value price-highlight">51600.00元</span> -->
                    <span class="info-value">{{theBookDetail.price}}.00元</span>
                  </div>
                </div>
              </div>
              
              <!-- 内部页面图片 -->
              <div class="internal-pages">
                <div class="section-title">
                  <i class="fas fa-images"></i>
                  <span>书籍影像</span>
                </div>
                <div class="pages-container">
                  <div 
                    class="scroll-btn left" 
                    @click="scrollPages('left')"
                    :class="{ disabled: currentPageScroll === 0 }"
                  >
                    <i class="fas fa-chevron-left"></i>
                  </div>
                  
                  <div class="pages-wrapper" ref="pagesWrapper">
                    <div 
                      v-for="(page, index) in internalPages" 
                      :key="index"
                      class="page-item"
                      @click="showImageDialog(page.img, page.title)"
                    >
                      <img 
                        :src="page.img" 
                        :alt="page.title"
                        @error="handleImageError"
                      >
                      <div class="page-hover">
                        <i class="fas fa-search-plus"></i>
                      </div>
                    </div>
                  </div>
                  
                  <div 
                    class="scroll-btn right" 
                    @click="scrollPages('right')"
                    :class="{ disabled: currentPageScroll >= internalPages.length - visiblePages }"
                  >
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 新增区域2：内容简介 -->
    <section class="book-description-section" v-if="isHaveContent">
      <div class="container">
        <div class="description-container classic-border classic-bg">
          <div class="section-title">
            <i class="fas fa-file-alt"></i>
            <span>内容简介</span>
          </div>
          <div class="description-content" ref="descriptionContent">
            <div class="scroll-content">
              <!-- <p>明代官方档案中的奏疏原件</p> -->
              {{theBookDetail.content}}
            </div>
          </div>
          <!-- <div class="scroll-indicator">
            <i class="fas fa-chevron-up" @click="scrollDescription('up')"></i>
            <i class="fas fa-chevron-down" @click="scrollDescription('down')"></i>
          </div> -->
        </div>
      </div>
    </section>

    <!-- 新增区域3：书籍宣传图片 -->
    <section class="book-promotion-section" v-if="isHavePicture">
      <div class="container">
        <div class="promotion-container classic-border classic-bg">
          <div class="section-title">
            <i class="fas fa-star"></i>
            <span>内容图片</span>
          </div>
          <div class="promotion-content">
            <div 
              class="scroll-btn left" 
              @click="scrollPromotion('left')"
              :class="{ disabled: currentPromotionScroll === 0 }"
            >
              <i class="fas fa-chevron-left"></i>
            </div>
            
            <div class="promotion-wrapper" ref="promotionWrapper">
              <div 
                v-for="(promo, index) in promotionImages" 
                :key="index"
                class="promo-item"
                @click="showImageDialog(promo.img, promo.title)"
              >
                <img 
                  :src="promo.img" 
                  :alt="promo.title"
                  @error="handleImageError"
                >
                <div class="promo-hover">
                  <i class="fas fa-search-plus"></i>
                  <span>点击查看大图</span>
                </div>
              </div>
            </div>
            
            <div 
              class="scroll-btn right" 
              @click="scrollPromotion('right')"
              :class="{ disabled: currentPromotionScroll >= promotionImages.length - 1 }"
            >
              <i class="fas fa-chevron-right"></i>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 第三区域：图书系列分册 -->
    <!-- <section class="main-section"> -->
    <section class="main-section" v-if="theBookDetail.booknums > 0">
      <div id="readSection" class="container">
        <div class="series-container classic-border classic-bg">
          <div class="series-header">
            <div class="series-info">
              <!-- 20260211 modify -->
              <!-- <div class="series-name">
                <span style="cursor: pointer;" @click="goBackPage">&lt;上页</span>
                -《{{theBookName}}》
              </div> -->
              <div class="series-name" v-if="!isMobile">
                <span style="cursor: pointer;" @click="goBackPage">&lt;上页</span>
                -《{{theBookName}}》
              </div>
              <div class="series-name" v-if="isMobile">
                <span><span style="cursor: pointer;" @click="goBackPage">&lt;上页</span>
                -《{{theBookName}}》</span>
              </div>

              <div class="series-total">
                <i class="fas fa-layer-group"></i>
                共{{totalBooks}}册
              </div>
            </div>
          </div>
          
          <div class="volumes-grid">
            <div 
              v-for="volume in currentVolumes" 
              :key="volume.id"
              class="volume-item classic-border"
              @click="handleVolumeClick(volume)"
            >
              <div class="volume-number">
                <span class="number-circle">第{{ volume.number }}册</span>
              </div>
              <div class="volume-content">
                <h3 class="volume-title">{{ volume.title }}</h3>
                <div class="volume-details">
                  <div class="detail-row">
                    <i class="fas fa-user-edit"></i>
                    <span class="detail-label">作者：</span>
                    <span class="detail-value">{{ volume.author }}</span>
                  </div>
                  <div class="detail-row">
                    <i class="fas fa-calendar-alt"></i>
                    <span class="detail-label">版本：</span>
                    <span class="detail-value">{{ volume.edition }}</span>
                  </div>
                  <div class="detail-row">
                    <i class="fas fa-file-alt"></i>
                    <span class="detail-label">页数：</span>
                    <span class="detail-value">{{ volume.pages }}页</span>
                  </div>
                </div>
              </div>
              <div class="volume-action" v-show="false">
                <el-button 
                  class="view-button" 
                  size="small"
                  @click.stop="handleViewClick(volume)"
                >
                  <i class="fas fa-eye"></i>
                  进入阅读
                </el-button>
              </div>
            </div>
          </div>
          
          <!-- 分页，如果存在数据 -->
          <div class="pagination" v-if="volumes.length>0">
            <div 
              class="pagination-prev"
              :class="{ disabled: currentPage === 1 }"
              @click="handlePrevPage"
            >
              上一页
            </div>
            <ul class="pagination-list">
              <li 
                v-for="page in visiblePages" 
                :key="page"
                class="pagination-item"
                :class="{ active: page === currentPage }"
                @click="handlePageClick(page)"
              >
                {{ page === 'ellipsis' ? '...' : page }}
              </li>
            </ul>
            <div 
              class="pagination-next"
              :class="{ disabled: currentPage === totalPages }"
              @click="handleNextPage"
            >
              下一页
            </div>
          </div>

          <!-- 分页，如果不存在数据 -->
          <div class="pagination" v-if="volumes.length==0">
            <div 
              class="pagination-prev"
              :class="{ disabled: currentPage === 1 }"
              @click="handlePrevPage"
            >
              上一页
            </div>
            <div 
              class="pagination-next"
              :class="{ disabled: currentPage === totalPages }"
              @click="handleNextPage"
            >
              下一页
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 第四区域：页脚 -->
    <abottom ref="abottom"></abottom>

    <!-- 图片查看对话框，20260211，pc电脑上对话框的宽度为屏幕的40%，手机上为90%,begin-->
    <el-dialog v-if="!isMobile"
      :visible.sync="showImageDialogVisible"
      :title="currentImageTitle"
      width="40%"
      :show-close="true"
      custom-class="image-dialog"
      @close="closeImageDialog"
    >
      <div class="dialog-image-container">
        <img 
          :src="currentImageSrc" 
          :alt="currentImageTitle"
          @error="handleImageError"
          class="dialog-image"
          ref="dialogImage"
        />
      </div>
    </el-dialog>
    <el-dialog v-if="isMobile"
      :visible.sync="showImageDialogVisible"
      :title="currentImageTitle"
      width="90%"
      :show-close="true"
      custom-class="image-dialog"
      @close="closeImageDialog"
    >
      <div class="dialog-image-container">
        <img 
          :src="currentImageSrc" 
          :alt="currentImageTitle"
          @error="handleImageError"
          class="dialog-image"
          ref="dialogImage"
        />
      </div>
    </el-dialog>
    <!-- 图片查看对话框，20260211，pc电脑上对话框的宽度为屏幕的40%，手机上为90%,end-->

    <!-- 更多分类弹出层 -->
    <el-dialog
      :visible.sync="showTagsModal"
      title="更多书籍分类"
      width="700px"
      :show-close="false"
      custom-class="custom-modal"
    >
      <div class="modal-tags">
        <div 
          v-for="tag in additionalTags"
          :key="tag"
          class="modal-tag"
          @click="handleModalTagClick(tag)"
        >
          {{ tag }}
        </div>
      </div>
      <div class="modal-description" v-if="showDescription">
        <p><strong>温馨提示：</strong>点击上方任意分类标签，该标签内容将自动填充到搜索框中，您可以直接进行搜索，或进一步细化搜索关键词。</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showTagsModal = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {getSingleBook, getBookDetail, getPublishDetail} from '../../api/home'
import { developmentUrl } from "../../config/env";

export default {
  name: 'ClassicBookWebsite',
  data() {
    return {
      theBookName:'',
      searchKeyword: '',
      showTagsModal: false,
      showDescription: true,
      isMobile: false,

      currentPage: 1,
      pageSizePc: 15,
      pageSizePh: 10,
      totalBooks: 0,

      additionalTags: [
        '东南亚文献', '南亚文献', '东北亚文献', '中国周边关系文献', 
        '一带一路', '区域国别文献', '各国馆藏文献', '域外古籍',
        '传世医学', '考古古物', '中国农学遗产文献', '商业经济文献', 
        '专题史料文献'
      ],
      volumes: [],
      theSeriesId: 0,
      theBookId: 0,
      theBookDetail: {},
      theBookCover: '',
      isHaveContent: false,
      isHavePicture: false,
      isWillPublish: false,

      defaultBookCover: 'data:image/svg+xml;utf8,<svg xmlns="http://192.168.1.104:8087/profile/upload/2026/01/21/%E5%8E%86%E4%BB%A3%E8%BE%B9%E4%BA%8B%E5%A5%8F%E7%96%8F%E8%BE%91%E5%BD%95%C2%B7%E6%98%8E%E4%BB%A3%C2%B7%E8%92%99%E5%8F%A4-%E8%A5%BF%E5%8C%97%E5%8D%B7_20260121200722A001.png" width="200" height="280" viewBox="0 0 200 280"><rect width="200" height="280" fill="#8b4513"/><rect x="10" y="10" width="180" height="260" fill="#f5deb3"/><text x="100" y="140" font-family="Arial" font-size="14" text-anchor="middle" fill="#5c3a21">书籍封面</text></svg>',

      // 新增数据
      showImageDialogVisible: false,
      currentImageSrc: '',
      currentImageTitle: '',
      currentPageScroll: 0,
      currentPromotionScroll: 0,
      visiblePagesCount: 4, // 计算内部页面可见数量，避免与visiblePages冲突
      internalPages: [],
      promotionImages: []
    }
  },
  computed: {
    currentVolumes() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.volumes.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.volumes.length / this.pageSize);
    },
    // 计算可见的页码 - 恢复原有的计算逻辑
    visiblePages() {
      const pages = []
      const maxVisible = 5
      
      if (this.totalPages <= maxVisible + 2) {
        // 如果总页数较少，显示所有页码
        for (let i = 1; i <= this.totalPages; i++) {
          pages.push(i)
        }
      } else {
        // 显示第一页
        pages.push(1)
        
        // 计算起始和结束页码
        let start = Math.max(2, this.currentPage - 1)
        let end = Math.min(this.totalPages - 1, this.currentPage + 1)
        
        // 调整起始和结束页码以确保显示足够的页码
        if (this.currentPage <= 3) {
          start = 2
          end = 4
        } else if (this.currentPage >= this.totalPages - 2) {
          start = this.totalPages - 3
          end = this.totalPages - 1
        }
        
        // 添加省略号
        if (start > 2) {
          pages.push('ellipsis')
        }
        
        // 添加中间页码
        for (let i = start; i <= end; i++) {
          pages.push(i)
        }
        
        // 添加省略号
        if (end < this.totalPages - 1) {
          pages.push('ellipsis')
        }
        
        // 显示最后一页
        pages.push(this.totalPages)
      }
      
      return pages
    },
    pageSize() {
      return this.isMobile ? this.pageSizePh : this.pageSizePc;
    }
  },
  mounted() {
    this.theBookName = this.$route.query.bookname;
    this.checkScreenWidth()
    window.addEventListener('resize', this.checkScreenWidth)
    document.addEventListener('click', this.handleDocumentClick)
    
    // 计算可见页面数量
    this.calculateVisiblePages()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenWidth)
    document.removeEventListener('click', this.handleDocumentClick)
  },
  created() {
    this.theSeriesId = this.$route.query.type;
    if(this.$route.query.type < 1000000000){
      this.GetBookDetail();
      this.isWillPublish = false;
    }
    else{
      this.GetPublishDetail();
      this.isWillPublish = true;
    }
    this.GetSingleBook();
  },
  methods: {
    GetSingleBook(){
      this.volumes = [];
      let queryParams = {};
      queryParams.bookseriesid = this.theSeriesId;
      getSingleBook(queryParams).then(response => {
        let listdata = [];
        listdata = response.data.rows;
        this.totalBooks = response.data.maprowdata.booknums;
        for(let i=0;i<listdata.length;i++){
          let onemap = {};
          onemap.id = listdata[i].id;
          onemap.number = i + 1;
          onemap.title = listdata[i].bookname;
          onemap.author = listdata[i].author;
          onemap.edition = listdata[i].version;
          onemap.pages = listdata[i].pagenums;
          this.volumes.push(onemap);

          this.theBookId = listdata[i].id;
        }
      })
    },

    GetBookDetail(){
      let queryParams = {};
      queryParams.id = this.theSeriesId;
      getBookDetail(queryParams).then(response => {
        let listdata = [];
        listdata = response.data.rows;
        this.theBookDetail = listdata[0];

        if(this.theBookDetail.content != ''){
          this.isHaveContent = true;
        }
        if(this.theBookDetail.contentpicture != ''){
          this.isHavePicture = true;
        }

        let pictureStr = this.theBookDetail.bookpicture.replace(/^\["/, '').replace(/"\]$/, '');
        this.theBookCover = developmentUrl + pictureStr.substring(1);

        let pictureUrlFix = developmentUrl.substring(0,developmentUrl.length-1);
        let mVisitPicture = this.theBookDetail.visitpicture.replace(/^\["/, '').replace(/"\]$/, '').replace(/"/g, '');
        let mVisitArr = mVisitPicture.split(',');
        this.internalPages = [];
          for(let i=0;i<mVisitArr.length;i++){
          let mapone = {};
          mapone.img = pictureUrlFix + mVisitArr[i];
          mapone.title = '书籍影像';
          this.internalPages.push(mapone);
        }
        
        let mContentPicture = this.theBookDetail.contentpicture.replace(/^\["/, '').replace(/"\]$/, '').replace(/"/g, '');
        let mContentArr = mContentPicture.split(',');
        this.promotionImages = [];
        for(let i=0;i<mContentArr.length;i++){
          let mapone = {};
          mapone.img = pictureUrlFix + mContentArr[i];
          mapone.title = '内容简介';
          this.promotionImages.push(mapone);
        }

      })
    },

    GetPublishDetail(){
      let queryParams = {};
      queryParams.id = this.theSeriesId;
      getPublishDetail(queryParams).then(response => {
        let listdata = [];
        listdata = response.data.rows;
        this.theBookDetail = listdata[0];

        if(this.theBookDetail.content != ''){
          this.isHaveContent = true;
        }
        if(this.theBookDetail.contentpicture != ''){
          this.isHavePicture = true;
        }
        
        let pictureStr = this.theBookDetail.bookpicture.replace(/^\["/, '').replace(/"\]$/, '');
        this.theBookCover = developmentUrl + pictureStr.substring(1);

        let pictureUrlFix = developmentUrl.substring(0,developmentUrl.length-1);
        let mVisitPicture = this.theBookDetail.visitpicture.replace(/^\["/, '').replace(/"\]$/, '').replace(/"/g, '');
        let mVisitArr = mVisitPicture.split(',');
        this.internalPages = [];
          for(let i=0;i<mVisitArr.length;i++){
          let mapone = {};
          mapone.img = pictureUrlFix + mVisitArr[i];
          mapone.title = '书籍影像';
          this.internalPages.push(mapone);
        }
        
        let mContentPicture = this.theBookDetail.contentpicture.replace(/^\["/, '').replace(/"\]$/, '').replace(/"/g, '');
        let mContentArr = mContentPicture.split(',');
        this.promotionImages = [];
        for(let i=0;i<mContentArr.length;i++){
          let mapone = {};
          mapone.img = pictureUrlFix + mContentArr[i];
          mapone.title = '内容简介';
          this.promotionImages.push(mapone);
        }

      })
    },

    checkScreenWidth() {
      this.isMobile = window.innerWidth <= 768;
      const newTotalPages = Math.ceil(this.volumes.length / this.pageSize);
      if (this.currentPage > newTotalPages) {
        this.currentPage = 1;
      }
      this.calculateVisiblePages()
    },
    
    calculateVisiblePages() {
      // 根据屏幕宽度计算可见的页面数量
      if (this.isMobile) {
        this.visiblePagesCount = 2;
      } else if (window.innerWidth <= 992) {
        this.visiblePagesCount = 3;
      } else {
        this.visiblePagesCount = 4;
      }
    },
    
    // 返回上页按钮点击事件
    goBackToPreviousPage() {
      this.$router.go(-1);
    },

    // 书籍阅读
    goReadPage() {
      if(this.theBookDetail.booknums > 0){
        const element = document.getElementById('readSection');
        if (element) {
          element.scrollIntoView({ 
            behavior: 'smooth',  // 平滑滚动
            block: 'start'       // 元素顶部对齐视口顶部
          });
        }
      }
      else{
        // 20260210,如果为手机则不进入阅读界面
        if(this.isMobile){
          return;
        }

        this.$router.push({
          path: '/vipread',
          query: { type: this.$route.query.type, twotype: this.theBookId, bookname:this.theBookDetail.seriesname }
        }).then(() => {
          window.scrollTo(0, 0)
        })
      }
    },
    
    // 图片查看方法
    showImageDialog(imgSrc, title) {
      /*20260211，书籍封面在手机上不要放大图片的效果*/
      if(this.isMobile && title == '书籍封面'){
        return;
      }

      this.currentImageSrc = imgSrc;
      this.currentImageTitle = title;
      this.showImageDialogVisible = true;
      
      // 在对话框显示后加载图片
      this.$nextTick(() => {
        if (this.$refs.dialogImage) {
          this.$refs.dialogImage.onload = () => {
            console.log('图片加载完成');
          };
        }
      });
    },
    
    closeImageDialog() {
      this.currentImageSrc = '';
      this.currentImageTitle = '';
    },
    
    // 滚动内部页面图片
    scrollPages(direction) {
      const wrapper = this.$refs.pagesWrapper;
      if (!wrapper) return;
      
      const itemWidth = this.isMobile ? 130 : 150;
      const gap = this.isMobile ? 8 : 10;
      const totalItemWidth = itemWidth + gap;
      
      if (direction === 'left') {
        this.currentPageScroll = Math.max(0, this.currentPageScroll - 1);
      } else {
        const maxScroll = this.internalPages.length - this.visiblePagesCount;
        this.currentPageScroll = Math.min(maxScroll, this.currentPageScroll + 1);
      }
      
      wrapper.scrollTo({
        left: this.currentPageScroll * totalItemWidth,
        behavior: 'smooth'
      });
    },
    
    // 滚动宣传图片
    scrollPromotion(direction) {
      const wrapper = this.$refs.promotionWrapper;
      if (!wrapper) return;
      
      const itemWidth = this.isMobile ? 250 : 400;
      const gap = this.isMobile ? 10 : 20;
      const totalItemWidth = itemWidth + gap;
      
      if (direction === 'left') {
        this.currentPromotionScroll = Math.max(0, this.currentPromotionScroll - 1);
      } else {
        this.currentPromotionScroll = Math.min(
          this.promotionImages.length - 1, 
          this.currentPromotionScroll + 1
        );
      }
      
      wrapper.scrollTo({
        left: this.currentPromotionScroll * totalItemWidth,
        behavior: 'smooth'
      });
    },
    
    // 滚动内容简介
    scrollDescription(direction) {
      const content = this.$refs.descriptionContent;
      if (!content) return;
      
      const scrollAmount = 100;
      
      if (direction === 'up') {
        content.scrollBy({ top: -scrollAmount, behavior: 'smooth' });
      } else {
        content.scrollBy({ top: scrollAmount, behavior: 'smooth' });
      }
    },
    
    handleSearch() {
      if (this.searchKeyword.trim()) {
        let _self = this
        _self.$router.push({path:'/searchpage',query: {type:'1'}})
      } else {
        this.$message({
          message: '请输入搜索关键词',
          type: 'warning'
        })
      }
    },
    handleVolumeClick(volume) {
      if(this.$route.query.type < 1000000000){
        // 20260210,如果为手机则不进入阅读界面
        if(this.isMobile){
          return;
        }

        this.$router.push({
          path: '/vipread',
          query: { type: this.$route.query.type, twotype: volume.id, bookname:volume.title }
        }).then(() => {
          window.scrollTo(0, 0)
        })
      }
      else{
        this.$message({
          message: `本书籍即将出版，敬请期待！`,
          type: 'success'
        })
      }
    },
    handleViewClick(volume) {
      this.$message({
        message: `进入分册《 ${volume.title} 的内部阅读页，该页面开发中`,
        type: 'success'
      })
    },
    handleModalTagClick(tag) {
      this.$message({
        message: `正在按"${tag}"分类进行搜索`,
        type: 'info'
      })
      console.log(`从弹出层选择分类搜索: ${tag}`)
      this.showTagsModal = false
      this.searchKeyword = tag
    },
    handlePageClick(page) {
      if (page === 'ellipsis') return
      this.currentPage = page
    },
    handlePrevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
      }
    },
    handleNextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
      }
    },
    handleDocumentClick(e) {},
    handleImageError(e) {
      console.error('图片加载失败:', e.target.src);
      
      // 设置备用图片
      if (e.target.src.includes('unsplash')) {
        // 如果Unsplash图片加载失败，使用备用图片
        if (e.target.src.includes('book-cover')) {
          e.target.src = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="300" height="400" viewBox="0 0 300 400"><rect width="300" height="400" fill="#8b4513"/><rect x="20" y="20" width="260" height="360" fill="#f5deb3"/><text x="150" y="200" font-family="Arial" font-size="18" text-anchor="middle" fill="#5c3a21">书籍封面</text><text x="150" y="230" font-family="Arial" font-size="14" text-anchor="middle" fill="#5c3a21">《历代边事奏疏辑录》</text></svg>';
        } else if (e.target.src.includes('page')) {
          e.target.src = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="150" height="200" viewBox="0 0 150 200"><rect width="150" height="200" fill="#a0522d"/><rect x="10" y="10" width="130" height="180" fill="#f5deb3"/><text x="75" y="100" font-family="Arial" font-size="12" text-anchor="middle" fill="#5c3a21">内部页面</text></svg>';
        } else if (e.target.src.includes('promo')) {
          e.target.src = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="400" height="300" viewBox="0 0 400 300"><rect width="400" height="300" fill="#8b4513"/><rect x="20" y="20" width="360" height="260" fill="#f5deb3"/><text x="200" y="150" font-family="Arial" font-size="16" text-anchor="middle" fill="#5c3a21">宣传图片</text><text x="200" y="180" font-family="Arial" font-size="12" text-anchor="middle" fill="#5c3a21">历代边事奏疏辑录</text></svg>';
        }
      }
    },

    goBackPage(){
      this.$router.go(-1)
    }

  }
}
</script>

<style scoped>
/* 引入外部字体和图标库 */
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css');
@import url('https://fonts.googleapis.com/css2?family=Ma+Shan+Zheng&family=Noto+Serif+SC:wght@400;600;700&display=swap');

/* 保持原有的CSS样式不变 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Noto Serif SC', serif;
  line-height: 1.6;
  color: #5c3a21;
  background-color: #f5f0e6;
  background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%239C8B7E' fill-opacity='0.08' fill-rule='evenodd'/%3E%3C/svg%3E");
  min-height: 100vh;
  overflow-x: hidden;
}

.container {
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 15px;
}

.classic-border {
  border: 1px solid #c9b18b;
  border-radius: 3px;
  box-shadow: 0 4px 8px rgba(92, 58, 33, 0.1);
}

.classic-bg {
  background-color: #fffaf0;
  border: 1px solid #d4c4a8;
}

/* 第一区域：顶部公司信息 */
.header-section {
  background-color: #8b4513;
  color: #f5deb3;
  padding: 19px 0;
  border-bottom: 3px solid #d2691e;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}

.logo-area {
  display: flex;
  align-items: center;
}

.logo {
  width: 60px;
  height: 60px;
  background-color: #f5deb3;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  border: 2px solid #d2691e;
  overflow: hidden;
}

.logo i {
  font-size: 2rem;
  color: #8b4513;
}

.logo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.site-name h1 {
  font-family: 'Noto Serif SC', serif;
  font-size: 1.8rem;
  color: #f5deb3;
  letter-spacing: 2px;
  text-shadow: 1px 1px 2px #5c3a21;
}

.site-name h1 span{
  font-size: 1.6rem;
}
.english-part {
  display: inline-flex;
  align-items: flex-end;
}
.moku {
  font-family: 'Noto Serif SC', serif;
  font-weight: 700;
}
.infinity {
  font-size: 1.2em;
  margin-left: 2px;
  line-height: 1;
}

.site-name p {
  font-size: 0.9rem;
  color: #e6d3b3;
  margin-top: 3px;
  font-family: 'Noto Serif SC', serif;
}

.contact-info {
  text-align: right;
}

.contact-info p {
  margin-bottom: 5px;
  font-size: 0.95rem;
  text-align: right;
  font-family: 'Noto Serif SC', serif;
}

/* 第二区域：全站搜索区 */
.search-section {
  padding: 25px 0;
  background-color: #D7B974;
  border-bottom: 2px dashed #8b4513;
}

.search-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.search-box {
  display: flex;
  width: 100%;
  max-width: 800px;
  margin-bottom: 0;
}

.search-icon {
  background-color: #8b4513;
  color: #f5deb3;
  padding: 15px 20px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  font-size: 1.2rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-input >>> .el-input__inner {
  padding: 18px;
  border: 1px solid #c9b18b;
  border-left: none;
  border-right: none;
  font-size: 1rem;
  font-family: 'Noto Serif SC', serif;
  background-color: #fffaf0;
  color: #5c3a21;
  min-width: 0;
  width: 100%;
  height: 100%;
  border-radius: 0;
}

.search-input >>> .el-input__inner::placeholder {
  color: #8b4513;
}

.search-input >>> .el-input__wrapper {
  padding: 0;
  border: none;
  border-radius: 0;
  background-color: #fffaf0;
  box-shadow: none;
}

.search-button {
  background-color: #a0522d;
  color: #f5deb3;
  border: none;
  padding: 0 25px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  font-family: 'Noto Serif SC', serif;
  font-weight: 600;
  transition: background-color 0.3s;
  flex-shrink: 0;
  height: auto;
}

.search-button:hover {
  background-color: #8b4513;
}

/* 新增区域1：书籍基本信息区域 */
.book-info-section {
  padding: 20px 0;
  background-color: #D7B974;
  border-top: 2px dashed #8b4513;
}

.book-info-container {
  padding: 25px;
  background-color: #fffaf0;
  border-radius: 5px;
  box-shadow: 0 4px 12px rgba(92, 58, 33, 0.08);
}

.book-info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  padding-bottom: 20px;
  border-bottom: 2px solid #d4c4a8;
}

.book-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 1.8rem;
  color: #8b4513;
  font-weight: 700;
  line-height: 1.4;
  text-shadow: 1px 1px 2px rgba(92, 58, 33, 0.1);
  margin: 0;
  flex: 1;
}

.back-button {
  background-color: #8b4513;
  color: #f5deb3;
  border: 2px solid #d2691e;
  border-radius: 25px;
  padding: 12px 25px;
  font-family: 'Noto Serif SC', serif;
  font-weight: 600;
  transition: all 0.3s;
  flex-shrink: 0;
  margin-left: 20px;
  font-size: 1.1rem;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-button:hover {
  background-color: #a0522d;
  border-color: #8b4513;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(92, 58, 33, 0.2);
}

.back-icon {
  font-size: 1.4rem;
  font-weight: bold;
  margin-right: 10px;
  display: inline-block;
  transform: translateY(-1px);
}

.back-text {
  font-size: 1.1rem;
  font-weight: 600;
}

.book-info-content {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
}

.book-cover {
  flex-shrink: 0;
  width: 300px;
  /*20260211*/
  /*height: 400px;*/
  height: 430px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  border: 2px solid #c9b18b;
  border-radius: 3px;
  transition: all 0.3s;
}

.book-cover:hover {
  border-color: #8b4513;
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(92, 58, 33, 0.2);
}

.book-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #f5deb3;
}

.cover-hover {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(92, 58, 33, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #f5deb3;
  opacity: 0;
  transition: opacity 0.3s;
  font-family: 'Noto Serif SC', serif;
}

.book-cover:hover .cover-hover {
  opacity: 1;
}

.cover-hover i {
  font-size: 2.5rem;
  margin-bottom: 10px;
}

.book-details {
  flex: 1;
  min-width: 300px;
}

.book-basic-info {
  margin-bottom: 30px;
  padding: 20px;
  background-color: #f9f5eb;
  border-radius: 5px;
  border: 1px solid #d4c4a8;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px 30px;
}

.info-item {
  display: flex;
  align-items: baseline;
  gap: 10px;
}

.info-label {
  font-family: 'Noto Serif SC', serif;
  font-weight: 600;
  color: #5c3a21;
  font-size: 1rem;
  min-width: 80px;
}

.info-value {
  font-family: 'Noto Serif SC', serif;
  color: #8b4513;
  font-size: 1rem;
  flex: 1;
}

.price-highlight {
  color: #d2691e;
  font-weight: 700;
  font-size: 1.1rem;
}

.internal-pages {
  margin-top: 20px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  font-family: 'Noto Serif SC', serif;
  font-size: 1.3rem;
  color: #8b4513;
  font-weight: 600;
}

.section-title i {
  color: #a0522d;
}

.pages-container {
  display: flex;
  align-items: center;
  gap: 15px;
  position: relative;
}

.pages-wrapper {
  flex: 1;
  display: flex;
  gap: 10px;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding: 10px 5px;
}

.pages-wrapper::-webkit-scrollbar {
  display: none;
}

.page-item {
  flex-shrink: 0;
  width: 150px;
  height: 200px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  border: 1px solid #c9b18b;
  border-radius: 3px;
  transition: all 0.3s;
}

.page-item:hover {
  border-color: #8b4513;
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(92, 58, 33, 0.15);
}

.page-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #f5deb3;
}

.page-hover {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(92, 58, 33, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
}

.page-item:hover .page-hover {
  opacity: 1;
}

.page-hover i {
  color: #f5deb3;
  font-size: 1.8rem;
}

.scroll-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9f5eb;
  border: 1px solid #c9b18b;
  border-radius: 50%;
  color: #5c3a21;
  cursor: pointer;
  transition: all 0.3s;
  flex-shrink: 0;
  z-index: 1;
}

.scroll-btn:hover {
  background-color: #8b4513;
  color: #f5deb3;
  border-color: #8b4513;
}

.scroll-btn.disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.scroll-btn.disabled:hover {
  background-color: #f9f5eb;
  color: #5c3a21;
  border-color: #c9b18b;
}

/* 新增区域2：内容简介 */
.book-description-section {
  padding: 20px 0;
  background-color: #D7B974;
}

.description-container {
  padding: 25px;
  background-color: #fffaf0;
  border-radius: 5px;
  box-shadow: 0 4px 12px rgba(92, 58, 33, 0.08);
  position: relative;
}

.description-content {
  height: 300px;
  overflow-y: auto;
  padding: 20px;
  background-color: #f9f5eb;
  border: 1px solid #d4c4a8;
  border-radius: 5px;
  font-family: 'Noto Serif SC', serif;
  line-height: 1.8;
  color: #5c3a21;
}

.description-content::-webkit-scrollbar {
  width: 6px;
}

.description-content::-webkit-scrollbar-track {
  background: #f0e6d2;
  border-radius: 3px;
}

.description-content::-webkit-scrollbar-thumb {
  background: #c9b18b;
  border-radius: 3px;
}

.description-content::-webkit-scrollbar-thumb:hover {
  background: #a0522d;
}

.scroll-content p {
  margin-bottom: 15px;
  text-indent: 2em;
}

.scroll-content ul,
.scroll-content ol {
  margin: 15px 0 15px 2em;
}

.scroll-content li {
  margin-bottom: 8px;
}

.scroll-content strong {
  color: #8b4513;
  font-weight: 600;
}

.scroll-indicator {
  position: absolute;
  right: 40px;
  top: 40px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.scroll-indicator i {
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9f5eb;
  border: 1px solid #c9b18b;
  border-radius: 50%;
  color: #5c3a21;
  cursor: pointer;
  transition: all 0.3s;
}

.scroll-indicator i:hover {
  background-color: #8b4513;
  color: #f5deb3;
  border-color: #8b4513;
}

/* 新增区域3：书籍宣传图片 */
.book-promotion-section {
  padding: 20px 0;
  background-color: #D7B974;
}

.promotion-container {
  padding: 25px;
  background-color: #fffaf0;
  border-radius: 5px;
  box-shadow: 0 4px 12px rgba(92, 58, 33, 0.08);
}

.promotion-content {
  display: flex;
  align-items: center;
  gap: 20px;
  position: relative;
}

.promotion-wrapper {
  flex: 1;
  display: flex;
  gap: 20px;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding: 10px 5px;
}

.promotion-wrapper::-webkit-scrollbar {
  display: none;
}

.promo-item {
  flex-shrink: 0;
  width: 400px;
  height: 300px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  border: 2px solid #c9b18b;
  border-radius: 5px;
  transition: all 0.3s;
}

.promo-item:hover {
  border-color: #8b4513;
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(92, 58, 33, 0.2);
}

.promo-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-color: #f5deb3;
}

.promo-hover {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(92, 58, 33, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #f5deb3;
  opacity: 0;
  transition: opacity 0.3s;
  font-family: 'Noto Serif SC', serif;
}

.promo-item:hover .promo-hover {
  opacity: 1;
}

.promo-hover i {
  font-size: 2.5rem;
  margin-bottom: 10px;
}

/* 第三区域：图书系列分册 */
.main-section {
  padding: 30px 0 40px;
  background-color: #D7B974;
  border-top: 2px dashed #8b4513;
}

.series-container {
  padding: 30px;
  background-color: #fffaf0;
  border-radius: 5px;
  box-shadow: 0 4px 12px rgba(92, 58, 33, 0.08);
}

/* 修改1：左右两部分的信息区域样式 */
.series-header {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 2px solid #d4c4a8;
}

.series-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
}

.series-name {
  font-family: 'Noto Serif SC', serif;
  font-size: 1.8rem;
  color: #8b4513;
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  min-width: 300px;
  letter-spacing: 2px;
}

.series-name i {
  color: #a0522d;
  font-size: 1.2rem;
}

.series-total {
  font-family: 'Noto Serif SC', serif;
  font-size: 1.3rem;
  color: #5c3a21;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #f9f5eb;
  padding: 10px 20px;
  border-radius: 25px;
  border: 1px solid #c9b18b;
}

.series-total i {
  color: #a0522d;
  font-size: 1.1rem;
}

.volumes-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.volume-item {
  background-color: #f9f5eb;
  padding: 20px;
  border-radius: 5px;
  display: flex;
  align-items: flex-start;
  gap: 15px;
  transition: all 0.3s;
  cursor: pointer;
  position: relative;
}

.volume-item:hover {
  background-color: #f0e6d2;
  transform: translateY(-3px);
  box-shadow: 0 6px 15px rgba(92, 58, 33, 0.15);
}

.volume-number {
  flex-shrink: 0;
  width: 80px;
}

.number-circle {
  display: inline-block;
  background-color: #8b4513;
  color: #f5deb3;
  padding: 8px 12px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
  text-align: center;
  font-family: 'Noto Serif SC', serif;
}

.volume-content {
  flex: 1;
  min-width: 0;
}

.volume-title {
  font-family: 'Noto Serif SC', serif;
  font-size: 1.2rem;
  color: #5c3a21;
  margin-bottom: 12px;
  line-height: 1.4;
  font-weight: 600;
}

.volume-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.detail-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 0.95rem;
  color: #5c3a21;
}

.detail-row i {
  color: #a0522d;
  width: 16px;
  flex-shrink: 0;
  margin-top: 2px;
}

.detail-label {
  font-weight: 600;
  font-family: 'Noto Serif SC', serif;
  flex-shrink: 0;
}

.detail-value {
  flex: 1;
  word-break: break-word;
  font-family: 'Noto Serif SC', serif;
}

.volume-action {
  flex-shrink: 0;
  align-self: center;
}

.view-button {
  background-color: #a0522d;
  color: #f5deb3;
  border: none;
  border-radius: 3px;
  padding: 8px 15px;
  font-family: 'Noto Serif SC', serif;
  font-size: 0.9rem;
  transition: background-color 0.3s;
}

.view-button:hover {
  background-color: #8b4513;
}

.view-button i {
  margin-right: 5px;
}

/* 分页区域样式 */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #d4c4a8;
  font-family: 'Noto Serif SC', serif;
}

.pagination-list {
  display: flex;
  list-style: none;
  gap: 8px;
}

.pagination-item {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9f5eb;
  border: 1px solid #c9b18b;
  border-radius: 3px;
  color: #5c3a21;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.3s;
}

.pagination-item:hover {
  background-color: #f0e6d2;
  border-color: #a0522d;
}

.pagination-item.active {
  background-color: #8b4513;
  color: #f5deb3;
  border-color: #8b4513;
  font-weight: 700;
}

.pagination-prev,
.pagination-next {
  width: 80px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9f5eb;
  border: 1px solid #c9b18b;
  border-radius: 3px;
  color: #5c3a21;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.3s;
  margin: 0 10px;
}

.pagination-prev:hover,
.pagination-next:hover {
  background-color: #f0e6d2;
  border-color: #a0522d;
}

.pagination-prev.disabled,
.pagination-next.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 第四区域：页脚 */
.footer-section {
  background-color: #5c3a21;
  color: #e6d3b3;
  padding: 25px 0;
  border-top: 3px solid #8b4513;
}

.footer-info {
  text-align: center;
  line-height: 1.8;
}

.footer-info p {
  margin-bottom: 8px;
  font-size: 0.95rem;
  font-family: 'Noto Serif SC', serif;
}

/* 图片对话框样式 - 优化让图片更大 */
.image-dialog >>> .el-dialog {
  background-color: #fffaf0;
  border-radius: 8px;
  border: 2px solid #c9b18b;
  max-width: 90vw;
}

.image-dialog >>> .el-dialog__header {
  border-bottom: 2px solid #d4c4a8;
  padding: 15px 20px;
  margin-bottom: 0;
}

.image-dialog >>> .el-dialog__title {
  font-family: 'Noto Serif SC', serif;
  font-size: 1.5rem;
  color: #8b4513;
}

.image-dialog >>> .el-dialog__body {
  padding: 5px;
  max-height: 85vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dialog-image-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f9f5eb;
  border-radius: 5px;
  padding: 0;
}

.dialog-image {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
  border: 1px solid #c9b18b;
  border-radius: 3px;
  background-color: #fff;
}

.image-dialog >>> .el-dialog__footer {
  padding: 10px 20px;
  border-top: 1px solid #d4c4a8;
}

/* 对话框自定义样式 */
.custom-modal >>> .el-dialog {
  background-color: #fffaf0;
  border-radius: 8px;
  border: 2px solid #c9b18b;
}

.custom-modal >>> .el-dialog__header {
  border-bottom: 2px solid #d4c4a8;
  padding-bottom: 15px;
  margin-bottom: 20px;
}

.custom-modal >>> .el-dialog__title {
  font-family: 'Noto Serif SC', serif;
  font-size: 1.8rem;
  color: #8b4513;
  letter-spacing: 1px;
}

.custom-modal >>> .el-dialog__body {
  padding: 0 30px 20px;
}

.custom-modal >>> .el-dialog__footer {
  border-top: 1px solid #d4c4a8;
  padding-top: 20px;
}

.modal-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 25px;
}

.modal-tag {
  background-color: #f9f5eb;
  border: 1px solid #c9b18b;
  padding: 12px 20px;
  border-radius: 25px;
  font-size: 1rem;
  color: #5c3a21;
  cursor: pointer;
  transition: all 0.3s;
  flex: 1;
  min-width: 200px;
  text-align: center;
}

.modal-tag:hover {
  background-color: #8b4513;
  color: #f5deb3;
  border-color: #8b4513;
  transform: translateY(-2px);
}

.modal-description {
  font-size: 1rem;
  line-height: 1.7;
  color: #5c3a21;
  background-color: #f9f5eb;
  padding: 20px;
  border-radius: 5px;
  border: 1px dashed #c9b18b;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .volumes-grid {
    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  }
  
  .book-info-content {
    gap: 25px;
  }
  
  .book-cover {
    width: 280px;
    height: 373px;
  }
  
  .book-title {
    font-size: 1.6rem;
  }
  
  .promo-item {
    width: 350px;
    height: 262px;
  }
}

@media (max-width: 992px) {
  .volumes-grid {
    grid-template-columns: 1fr;
  }
  
  .custom-modal >>> .el-dialog {
    width: 95%;
  }
  
  .modal-tag {
    min-width: 150px;
  }
  
  .series-name {
    font-size: 1.3rem;
  }
  
  .series-total {
    font-size: 1.2rem;
  }
  
  .book-info-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .back-button {
    align-self: flex-end;
    margin-left: 0;
    margin-top: 10px;
    padding: 10px 20px;
    font-size: 1rem;
  }
  
  .back-icon {
    font-size: 1.3rem;
    margin-right: 8px;
  }
  
  .book-info-content {
    flex-direction: column;
  }
  
  .book-cover {
    width: 100%;
    max-width: 350px;
    height: 467px;
    margin: 0 auto;
  }
  
  .book-details {
    width: 100%;
  }
  
  .info-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .promo-item {
    width: 320px;
    height: 240px;
  }
}

@media (max-width: 768px) {
  /*20260211 add,适配手机,begin*/
  .book-cover {
    flex-shrink: 0;
    width: 300px;
    height: 430px !important;
    position: relative;
    cursor: pointer;
    overflow: hidden;
    border: 2px solid #c9b18b;
    border-radius: 3px;
    transition: all 0.3s;
  }

  .info-item {
    display: grid;
    grid-template-columns: 1fr auto; /* 左边自适应，右边自动宽度 */
    align-items: baseline;
    width: 100%;
    gap: 10px; /* 可选的间距 */
  }

  .info-label {
    font-family: 'Noto Serif SC', serif;
    font-weight: 600;
    color: #5c3a21;
    font-size: 1rem;
    text-align: left;
    justify-self: start; /* 网格内左对齐 */
  }

  .info-value {
    font-family: 'Noto Serif SC', serif;
    color: #8b4513;
    font-size: 1rem;
    text-align: right;
    justify-self: end; /* 网格内右对齐 */
  }

  .back-icon {
    font-size: 1.1rem;
    margin-right: 3px;
  }
  /*20260211 add,适配手机,end*/

  .header-container {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .contact-info {
    text-align: left;
    margin-top: 15px;
  }
  
  .site-name h1 {
    font-size: 1.5rem;
  }
  
  /* 搜索框不换行 */
  .search-box {
    flex-direction: row;
    overflow: hidden;
  }
  
  .search-icon, .search-input, .search-button {
    border-radius: 0;
    border: 1px solid #c9b18b;
    margin: 0;
    width: auto;
    flex-shrink: 0;
  }
  
  .search-icon {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    text-align: center;
    padding: 15px;
    width: 50px;
  }
  
  .search-input >>> .el-input__inner {
    flex: 1;
    min-width: 0;
    border-left: none;
    border-right: none;
    padding: 15px 10px;
  }
  
  .search-button {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    padding: 15px 20px;
    white-space: nowrap;
  }
  
  .series-container {
    padding: 20px;
  }
  
  /* 移动端系列信息布局 */
  .series-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .series-name {
    font-size: 1.2rem;
    min-width: 100%;
  }
  
  .series-total {
    align-self: flex-start;
    font-size: 1.1rem;
    padding: 8px 15px;
  }
  
  .volume-item {
    flex-direction: column;
    gap: 12px;
    padding: 15px;
  }
  
  .volume-number {
    width: 100%;
    text-align: center;
  }
  
  .volume-content {
    width: 100%;
  }
  
  .volume-title {
    font-size: 1.1rem;
  }
  
  .volume-action {
    width: 100%;
    text-align: center;
  }
  
  .view-button {
    width: 100%;
  }
  
  .custom-modal >>> .el-dialog {
    width: 98%;
  }
  
  .modal-tags {
    gap: 10px;
  }
  
  .modal-tag {
    min-width: 120px;
    padding: 10px 15px;
    font-size: 0.9rem;
  }
  
  /* 移动端分页样式 */
  .pagination-list {
    gap: 5px;
  }
  
  .pagination-item {
    width: 35px;
    height: 35px;
    font-size: 0.85rem;
  }
  
  .pagination-prev,
  .pagination-next {
    width: 70px;
    height: 35px;
    font-size: 0.85rem;
    margin: 0 5px;
  }
  
  .book-info-container,
  .description-container,
  .promotion-container {
    padding: 20px;
  }
  
  .book-title {
    font-size: 1.4rem;
  }
  
  .section-title {
    font-size: 1.2rem;
  }
  
  .info-label {
    min-width: 70px;
    font-size: 0.95rem;
  }
  
  .info-value {
    font-size: 0.95rem;
  }
  
  .description-content {
    height: 250px;
    padding: 15px;
  }
  
  .scroll-indicator {
    right: 30px;
    top: 30px;
  }
  
  .scroll-indicator i {
    width: 30px;
    height: 30px;
    font-size: 0.9rem;
  }
  
  .promo-item {
    width: 280px;
    height: 210px;
  }
  
  .scroll-btn {
    width: 35px;
    height: 35px;
    font-size: 0.9rem;
  }
  
  .pages-wrapper,
  .promotion-wrapper {
    gap: 8px;
  }
  
  .page-item {
    width: 130px;
    height: 173px;
  }
}

@media (max-width: 576px) {
  .site-name h1 {
    font-size: 1.3rem;
  }
  
  .logo {
    width: 50px;
    height: 50px;
  }
  
  .logo i {
    font-size: 1.5rem;
  }
  
  .contact-info p {
    font-size: 0.85rem;
  }
  
  .volumes-grid {
    gap: 15px;
  }
  
  .series-name {
    font-size: 1.1rem;
    gap: 8px;
  }
  
  .series-name i {
    font-size: 1rem;
  }
  
  .series-total {
    font-size: 1rem;
    padding: 6px 12px;
  }
  
  .series-total i {
    font-size: 0.9rem;
  }
  
  .volume-title {
    font-size: 1rem;
  }
  
  .detail-row {
    font-size: 0.9rem;
  }
  
  .footer-info p {
    font-size: 0.85rem;
  }
  
  .modal-tag {
    min-width: 100%;
  }
  
  /* 手机上进一步优化搜索框 */
  .search-icon {
    width: 45px;
    padding: 12px;
  }
  
  .search-button {
    padding: 12px 15px;
    font-size: 0.9rem;
  }
  
  .search-input >>> .el-input__inner {
    padding: 12px 8px;
    font-size: 0.9rem;
  }
  
  /* 小屏幕分页样式 */
  .pagination-list {
    flex-wrap: wrap;
    justify-content: center;
    gap: 3px;
  }
  
  .pagination-item {
    width: 30px;
    height: 30px;
    font-size: 0.85rem;
  }
  
  .pagination-prev,
  .pagination-next {
    width: 60px;
    height: 30px;
    font-size: 0.85rem;
    margin: 0 3px;
  }
  
  .book-title {
    font-size: 1.2rem;
  }
  
  .book-cover {
    height: 400px;
  }
  
  .section-title {
    font-size: 1.1rem;
  }
  
  .info-item {
    flex-direction: column;
    gap: 5px;
  }
  
  .info-label {
    min-width: auto;
  }
  
  .description-content {
    height: 200px;
    font-size: 0.95rem;
    line-height: 1.7;
  }
  
  .scroll-content p {
    text-indent: 1.5em;
    margin-bottom: 12px;
  }
  
  .scroll-content ul,
  .scroll-content ol {
    margin-left: 1.5em;
  }
  
  .promo-item {
    width: 250px;
    height: 188px;
  }
  
  .promo-hover i {
    font-size: 2rem;
  }
  
  .page-item {
    width: 110px;
    height: 147px;
  }
  
  .scroll-btn {
    width: 30px;
    height: 30px;
    font-size: 0.8rem;
  }
}

@media (max-width: 400px) {
  .site-name h1 {
    font-size: 1.2rem;
  }
  
  /* 超小屏幕搜索框优化 */
  .search-icon {
    width: 40px;
    padding: 10px;
    font-size: 1rem;
  }
  
  .search-button {
    padding: 10px 12px;
    font-size: 0.85rem;
  }
  
  .search-input >>> .el-input__inner {
    padding: 10px 6px;
    font-size: 0.85rem;
  }
  
  .series-container {
    padding: 15px;
  }
  
  .series-name {
    font-size: 1rem;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }
  
  .series-total {
    font-size: 0.95rem;
    padding: 5px 10px;
  }
  
  .volume-title {
    font-size: 0.95rem;
  }
  
  .detail-row {
    font-size: 0.85rem;
  }
  
  .number-circle {
    font-size: 0.85rem;
    padding: 6px 10px;
  }
  
  .view-button {
    padding: 6px 10px;
    font-size: 0.85rem;
  }
  
  /* 超小屏幕分页样式 */
  .pagination-list {
    gap: 2px;
  }
  
  .pagination-item {
    width: 28px;
    height: 28px;
    font-size: 0.8rem;
  }
  
  .pagination-prev,
  .pagination-next {
    width: 55px;
    height: 28px;
    font-size: 0.8rem;
    margin: 0 2px;
  }
  
  .book-info-container,
  .description-container,
  .promotion-container {
    padding: 15px;
  }
  
  .book-title {
    font-size: 1.1rem;
  }
  
  .book-cover {
    height: 350px;
  }
  
  .section-title {
    font-size: 1rem;
  }
  
  .description-content {
    height: 180px;
    font-size: 0.9rem;
  }
  
  .scroll-indicator {
    right: 20px;
    top: 20px;
  }
  
  .scroll-indicator i {
    width: 25px;
    height: 25px;
    font-size: 0.8rem;
  }
  
  .promo-item {
    width: 220px;
    height: 165px;
  }
  
  .promo-hover i {
    font-size: 1.8rem;
  }
  
  .promo-hover span {
    font-size: 0.9rem;
  }
  
  .page-item {
    width: 100px;
    height: 133px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/singlebook/index.vue